import { Injectable } from "@angular/core";
import { FormControl } from "@angular/forms";

@Injectable()
export class UtilityService {
  validateNumber(formControl: FormControl) {
    if (
      formControl &&
      formControl.value &&
      typeof formControl.value === "string" &&
      !formControl.value.replace(/\s/g, "").length
    ) {
      formControl.setValue("");
      return (formControl.value || "").trim().length
        ? null
        : { whitespace: true };
    } else {
      return null;
    }
  }

  validateEmail(formControl: FormControl) {
    const regex = new RegExp(
      // tslint:disable-next-line:max-line-length
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (formControl.value && formControl.value.length) {
      if (!regex.test(formControl.value)) {
        return {
          invalidEmail: true,
        };
      } else {
        return null;
      }
    }
  }
  getParentBaseUrl(withScheme?: boolean) {
    let parentBaseUrl = "";
    const hostname = window.location.hostname;
    if (hostname === "localhost") {
      parentBaseUrl = hostname;
    } else {
      const subDomainName = hostname.split(".")[0];
      const splittedSubDomain = subDomainName.split("-");
      parentBaseUrl = `${splittedSubDomain[splittedSubDomain.length - 2]}.${
        splittedSubDomain[splittedSubDomain.length - 1]
      }`;
    }
    if (withScheme) {
      return `https://${parentBaseUrl}`;
    } else {
      return parentBaseUrl;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utility.service.ts